/**
 * Brands Grid
 */
(() => {
  // Function to create loading placeholder
  function createLoadingPlaceholder() {
    const placeholder = document.createElement('div');
    placeholder.className = 'brand-card loading-placeholder';
    placeholder.innerHTML = `
      <div class="brand-image skeleton" style="width: 100%; height: 100%;"></div>
    `;
    return placeholder;
  }

  // Function to create brand card
  function createBrandCard(brand) {
    const card = document.createElement('div');
    card.className = 'brand-card';
    card.innerHTML = `
      <a href="/searchbrand?querybrand=${brand.brand_id}&name=${encodeURIComponent(brand.name)}">
        <img src="${brand.image_path}" alt="${brand.name}">
      </a>
    `;
    return card;
  }

  // Function to create brand containers
  function createBrandContainers() {
    const container1 = document.createElement('div');
    const container2 = document.createElement('div');
    container1.className = 'brands-container active';
    container2.className = 'brands-container';
    return [container1, container2];
  }

  // Function to create control buttons
  function createControlButtons() {
    const controls = document.createElement('div');
    controls.className = 'brand-controls';
    const button1 = document.createElement('button');
    button1.className = 'brand-control page-1';
    button1.innerHTML = '1';
    button1.setAttribute('aria-label', 'Show first set of brands');
    const button2 = document.createElement('button');
    button2.className = 'brand-control page-2';
    button2.innerHTML = '2';
    button2.setAttribute('aria-label', 'Show second set of brands');
    controls.appendChild(button1);
    controls.appendChild(button2);
    return controls;
  }

  // Function to handle fade animation between containers
  function startFadeAnimation(brandsGrid) {
    const containers = brandsGrid.querySelectorAll('.brands-container');
    const controls = brandsGrid.querySelector('.brand-controls');
    let currentIndex = 0;
    let fadeInterval;

    function updateControlStates() {
      const button1 = controls.querySelector('.page-1');
      const button2 = controls.querySelector('.page-2');
      button1.classList.toggle('active', currentIndex === 0);
      button2.classList.toggle('active', currentIndex === 1);
    }

    function fadeToNext() {
      containers[currentIndex].classList.remove('active');
      currentIndex = (currentIndex + 1) % containers.length;
      containers[currentIndex].classList.add('active');
      updateControlStates();
    }

    function fadeToPrev() {
      containers[currentIndex].classList.remove('active');
      currentIndex = (currentIndex - 1 + containers.length) % containers.length;
      containers[currentIndex].classList.add('active');
      updateControlStates();
    }

    function handleMouseEnter() {
      if (fadeInterval) {
        clearInterval(fadeInterval);
      }
    }

    function handleMouseLeave() {
      fadeInterval = setInterval(fadeToNext, 5000);
    }

    function handleButton1Click() {
      if (currentIndex !== 0) {
        fadeToPrev();
      }
    }

    function handleButton2Click() {
      if (currentIndex !== 1) {
        fadeToNext();
      }
    }

    // Set up event listeners
    brandsGrid.addEventListener('mouseenter', handleMouseEnter);
    brandsGrid.addEventListener('mouseleave', handleMouseLeave);

    const button1 = controls.querySelector('.page-1');
    const button2 = controls.querySelector('.page-2');

    button1.addEventListener('click', handleButton1Click);
    button2.addEventListener('click', handleButton2Click);

    // Start the fade interval
    fadeInterval = setInterval(fadeToNext, 5000);
    updateControlStates();
  }

  // Function to load the brands grid content
  function loadBrandsGrid(brandsGrid) {
    const brandsId = brandsGrid.getAttribute('data-brands');
    if (!brandsId) {
      console.warn('Missing required elements:', { brandsId });
      return;
    }

    const containers = brandsGrid.querySelector('.brands-grid__containers');

    // Add loading placeholders
    const loadingPlaceholders = Array.from({ length: 11 }, () => createLoadingPlaceholder());
    const [container1, container2] = createBrandContainers();
    const controls = createControlButtons();

    loadingPlaceholders.forEach((placeholder) => {
      container1.appendChild(placeholder);
      container2.appendChild(createLoadingPlaceholder());
    });

    containers.appendChild(container1);
    containers.appendChild(container2);
    brandsGrid.appendChild(controls);

    $.ajax({
      type: 'post',
      url: '/ajax/merchandising',
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
      },
      data: { groupBrandMerchandising_ids: [brandsId] },
      success(response) {
        if (!response.data.brandmerchandising?.[brandsId]) {
          console.warn('No brand merchandising data received');
          return;
        }

        const brands = response.data.brandmerchandising[brandsId];
        const brandsPerContainer = 11;

        // Clear containers
        container1.innerHTML = '';
        container2.innerHTML = '';

        // Split brands into two groups
        const firstGroup = brands.slice(0, brandsPerContainer);
        const secondGroup = brands.slice(brandsPerContainer, brandsPerContainer * 2);

        // Populate containers
        firstGroup.forEach((brand) => container1.appendChild(createBrandCard(brand)));
        secondGroup.forEach((brand) => container2.appendChild(createBrandCard(brand)));

        // Start the fade animation
        startFadeAnimation(brandsGrid);
      },
      error(err) {
        console.error('Error fetching brand data:', err);
      },
    });
  }

  // Create an intersection observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const brandsGrid = entry.target;
        loadBrandsGrid(brandsGrid);
        // Once loaded, we don't need to observe this element anymore
        observer.unobserve(brandsGrid);
      }
    });
  }, {
    rootMargin: '200px 0px', // Start loading when grid is 50px from viewport
    threshold: 0.1,
  });

  // Start observing all brand grids
  document.querySelectorAll('.brands-grid').forEach((brandsGrid) => {
    observer.observe(brandsGrid);
  });
})();
